import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "user-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12 2.75C14.6234 2.75 16.75 4.87665 16.75 7.5C16.75 10.1234 14.6234 12.25 12 12.25C9.37665 12.25 7.25 10.1234 7.25 7.5C7.25 4.87665 9.37665 2.75 12 2.75ZM15.25 7.5C15.25 5.70507 13.7949 4.25 12 4.25C10.2051 4.25 8.75 5.70507 8.75 7.5C8.75 9.29493 10.2051 10.75 12 10.75C13.7949 10.75 15.25 9.29493 15.25 7.5Z"
    }, null, -1),
    _createElementVNode("path", { d: "M10.002 13.7555C6.82631 13.7555 4.25195 16.3299 4.25195 19.5055V20.5C4.25195 20.9142 4.58774 21.25 5.00195 21.25C5.41617 21.25 5.75195 20.9142 5.75195 20.5V19.5055C5.75195 17.1583 7.65474 15.2555 10.002 15.2555H13.998C16.3453 15.2555 18.248 17.1583 18.248 19.5055V20.5C18.248 20.9142 18.5838 21.25 18.998 21.25C19.4123 21.25 19.748 20.9142 19.748 20.5V19.5055C19.748 16.3299 17.1737 13.7555 13.998 13.7555H10.002Z" }, null, -1)
  ])))
}
export default { render: render }